import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=2d06e03a&scoped=true&"
import script from "./Editable.vue?vue&type=script&lang=js&"
export * from "./Editable.vue?vue&type=script&lang=js&"
import style0 from "./Editable.vue?vue&type=style&index=0&id=2d06e03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06e03a",
  null
  
)

export default component.exports